import {createTheme} from "@mui/material/styles";
export const theme = createTheme({
  palette: {
    primary: {
      main: "#499e93",
    },
    secondary: {main: "#0a183a"},
    warning: {main: "#e5383b"},
  },
  typography: {
    fontFamily: "Montserrat",
  },
});
